import { render, staticRenderFns } from "./TinyPlafond.vue?vue&type=template&id=45fc9261&scoped=true"
import script from "./TinyPlafond.vue?vue&type=script&lang=js"
export * from "./TinyPlafond.vue?vue&type=script&lang=js"
import style0 from "./TinyPlafond.vue?vue&type=style&index=0&id=45fc9261&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45fc9261",
  null
  
)

export default component.exports